<template xmlns="http://www.w3.org/1999/html">
    <div>
        <h2>{{ step.title }}</h2>
        <p>Please upload photos of each page of your benefits letter.</p><br>
         <h4>Remember, the photo of your document must be:</h4><br>
        <ul>
            <li>Of an authentic and original ID document (not a copy of one) </li>
            <li>Clear and in focus (so that the information on your document is readable)</li>
            <li>In colour</li>
            <li>Unaltered by computer software in any way</li>
        </ul><br>
          <img src="https://images.ctfassets.net/2tjc93jinw29/6FCAtxJ5tIXbCuqAgVWc49/09b7d20568d8fa9d3e5e0a7294a771f9/selfie2.jpg?h=600" alt="" class="responsive">

        <InputRadioGroup
            name="Benefit_Letter"
            :required="checkIsRequired('Benefit_Letter')"
            :error="formRef.errors.get('Benefit_Letter')"
            v-model="formRef.Benefit_Letter"
            :options="getField('Benefit_Letter').options"
        >
            <template v-slot:question>
                {{ getField("Benefit_Letter").question }}
            </template>
        </InputRadioGroup>
        <div id="documentList"></div><br/>

        <InputFile
            @input="handleFileInput"
            :error="formRef.errors?.get('file')"
            accept="image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text"
            :multiple="true"
        />
    </div>
</template>

<script setup>
import InputRadioGroup from "../Form/InputRadioGroup.vue";
import InputFile from "../Form/InputFile.vue";
import Form from "../../../js/Form";
import { isRequired } from "../Application/formHelper";
import { ref, markRaw } from "vue";

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

const emit = defineEmits(['input', 'buttonDisabled'])

let formRef = markRaw(ref(new Form({
    file: null
}, {...props.formData})))

const getField = (fieldName) => {
   return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
   var fieldData = getField(fieldName);
   return isRequired(fieldData, formRef.value);
}

function handleFileInput(files) {
    emit("input", files.length);
    if (files.length > 6){
        formRef.value.file = null; 
    } else {
        formRef.value.file = files;
        emit("buttonDisabled", false); 
    }    
}

defineExpose({
    formRef
})
</script>

<style scoped>
.responsive {
  width: 100%;
  height: auto;
  padding-left: 10%;
  margin-bottom: 10%;
}
</style>